/**
 * Slovak Translations — Impact Core i18n
 *
 * Flat key-value structure. Keys use dot notation for namespacing.
 * Coverage: navigation, actions, statuses, dashboard labels, form labels.
 */

export const sk: Record<string, string> = {
  // Navigation
  'nav.dashboard': 'Prehľad',
  'nav.funds': 'Fondy',
  'nav.investments': 'Investície',
  'nav.investees': 'Príjemcovia investícií',
  'nav.esg': 'ESG Preskúmanie',
  'nav.compliance': 'Súlad',
  'nav.reports': 'Správy',
  'nav.settings': 'Nastavenia',
  'nav.users': 'Používatelia',
  'nav.sfdr': 'SFDR',
  'nav.pai': 'PAI Ukazovatele',
  'nav.taxonomy': 'Taxonómia EÚ',
  'nav.filings': 'Podania',
  'nav.calendar': 'Kalendár',
  'nav.submit': 'Odoslať údaje',
  'nav.submissions': 'Moje podania',
  'nav.benchmarks': 'Referenčné hodnoty',
  'nav.messages': 'Správy',
  'nav.portfolio': 'Portfólio',
  'nav.performance': 'Výkonnosť fondov',
  'nav.esgSummary': 'ESG Súhrn',
  'nav.pipeline': 'Pipeline',
  'nav.dueDiligence': 'Hĺbková kontrola',
  'nav.impact': 'Ukazovatele dopadu',
  'nav.sdg': 'Mapovanie CUR',
  'nav.audit': 'Auditná stopa',
  'nav.snapshots': 'Dátové snímky',
  'nav.knowledgeGraph': 'Graf znalostí',
  'nav.geographic': 'Geografický',
  'nav.bi': 'BI Štúdio',
  'nav.ai': 'AI Asistent',
  'nav.tasks': 'Úlohy',
  'nav.csrd': 'CSRD',
  'nav.regulatory': 'Regulačný monitor',

  // Common Actions
  'action.create': 'Vytvoriť',
  'action.edit': 'Upraviť',
  'action.delete': 'Odstrániť',
  'action.save': 'Uložiť',
  'action.cancel': 'Zrušiť',
  'action.submit': 'Odoslať',
  'action.approve': 'Schváliť',
  'action.reject': 'Zamietnuť',
  'action.download': 'Stiahnuť',
  'action.export': 'Exportovať',
  'action.import': 'Importovať',
  'action.filter': 'Filtrovať',
  'action.search': 'Hľadať',
  'action.refresh': 'Obnoviť',
  'action.close': 'Zavrieť',
  'action.back': 'Späť',
  'action.next': 'Ďalej',
  'action.previous': 'Predchádzajúci',
  'action.viewAll': 'Zobraziť všetko',
  'action.viewDetails': 'Zobraziť podrobnosti',
  'action.generate': 'Generovať',
  'action.signOut': 'Odhlásiť sa',
  'action.addNew': 'Pridať nové',
  'action.invite': 'Pozvať',

  // Statuses
  'status.draft': 'Návrh',
  'status.submitted': 'Odoslané',
  'status.validated': 'Validované',
  'status.approved': 'Schválené',
  'status.rejected': 'Zamietnuté',
  'status.pending': 'Čakajúce',
  'status.inProgress': 'Prebieha',
  'status.overdue': 'Po termíne',
  'status.compliant': 'V súlade',
  'status.filed': 'Podané',
  'status.active': 'Aktívne',
  'status.inactive': 'Neaktívne',
  'status.closed': 'Uzavreté',
  'status.fundraising': 'Získavanie prostriedkov',
  'status.investing': 'Investovanie',
  'status.harvesting': 'Zber',

  // Dashboard Labels
  'dashboard.portfolioOverview': 'Prehľad portfólia',
  'dashboard.complianceStatus': 'Stav súladu',
  'dashboard.collectionProgress': 'Priebeh zberu',
  'dashboard.activityFeed': 'Aktivita',
  'dashboard.quickActions': 'Rýchle akcie',
  'dashboard.investmentPipeline': 'Investičný pipeline',
  'dashboard.totalFunds': 'Celkom fondov',
  'dashboard.aum': 'AUM',
  'dashboard.activeInvestments': 'Aktívne investície',
  'dashboard.totalInvestees': 'Príjemcovia investícií',
  'dashboard.recentActivity': 'Nedávna aktivita',

  // LP Dashboard Labels
  'lp.totalCommitted': 'Celkom záväzkov',
  'lp.capitalCalled': 'Vyžiadaný kapitál',
  'lp.distributed': 'Distribuované',
  'lp.netPosition': 'Čistá pozícia',
  'lp.tvpi': 'TVPI',
  'lp.dpi': 'DPI',
  'lp.fundPerformance': 'Výkonnosť fondov',
  'lp.esgSummary': 'ESG Súhrn',
  'lp.reportLibrary': 'Knižnica správ',
  'lp.taxonomyAligned': 'Súlad s taxonómiou',
  'lp.paiCoverage': 'PAI Pokrytie',
  'lp.portfolioPerformance': 'Výkonnosť LP portfólia',

  // Fund Labels
  'fund.name': 'Názov fondu',
  'fund.code': 'Kód fondu',
  'fund.vintage': 'Rok vzniku',
  'fund.size': 'Veľkosť fondu',
  'fund.targetSize': 'Cieľová veľkosť',
  'fund.currency': 'Mena',
  'fund.strategy': 'Stratégia',
  'fund.status': 'Stav',
  'fund.sfdrCategory': 'SFDR Kategória',
  'fund.geographyFocus': 'Geografické zameranie',
  'fund.sectorFocus': 'Sektorové zameranie',

  // Form Labels
  'form.name': 'Názov',
  'form.email': 'E-mail',
  'form.country': 'Krajina',
  'form.amount': 'Čiastka',
  'form.currency': 'Mena',
  'form.date': 'Dátum',
  'form.description': 'Popis',
  'form.notes': 'Poznámky',
  'form.type': 'Typ',
  'form.period': 'Obdobie',
  'form.year': 'Rok',
  'form.required': 'Povinné',
  'form.optional': 'Nepovinné',

  // Table Headers
  'table.fund': 'Fond',
  'table.commitment': 'Záväzok',
  'table.called': 'Vyžiadané',
  'table.distributed': 'Distribuované',
  'table.tvpi': 'TVPI',
  'table.status': 'Stav',
  'table.regulation': 'Regulácia',
  'table.filingType': 'Typ podania',
  'table.reportingPeriod': 'Obdobie',
  'table.createdAt': 'Vytvorené',
  'table.actions': 'Akcie',

  // Compliance
  'compliance.sfdr': 'SFDR',
  'compliance.taxonomy': 'Taxonómia EÚ',
  'compliance.pai': 'PAI',
  'compliance.dataCompleteness': 'Úplnosť údajov',
  'compliance.nextDeadline': 'Nasledujúci termín',

  // Reports
  'report.quarterly': 'Štvrťročná správa',
  'report.annual': 'Výročná správa',
  'report.paiStatement': 'PAI Vyhlásenie',
  'report.taxonomyReport': 'Správa o taxonómii',
  'report.generatedAt': 'Vygenerované',
  'report.version': 'Verzia',

  // General
  'general.loading': 'Načítavanie...',
  'general.noData': 'Žiadne dostupné údaje',
  'general.error': 'Vyskytla sa chyba',
  'general.retry': 'Skúsiť znova',
  'general.total': 'Celkom',
  'general.page': 'Stránka',
  'general.of': 'z',
  'general.showing': 'Zobrazenie',
  'general.results': 'výsledkov',
  'general.language': 'Jazyk',
  'general.english': 'Angličtina',
  'general.french': 'Francúzština',

  // Tour
  'tour.takeTour': 'Spustiť prehliadku',
  'tour.skip': 'Preskočiť',
  'tour.next': 'Ďalší',
  'tour.prev': 'Predchádzajúci',
  'tour.finish': 'Dokončiť',
};
